<div class="modal-header">
  <h5 class="modal-title"
      id="addRoomModalLabel">Add room</h5>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <form>
    <div>
      <label for="roomNumber"
             class="form-label">Room number: </label>
      <input class="form-control"
             id="roomNumber"
             type="text"
             [formControl]="roomNumberForm" />
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button"
          class="btn btn-secondary"
          (click)="activeModal.close('Close click')">Close</button>
  <button type="button"
          class="btn btn-primary"
          (click)="onSubmit()">Save room</button>
</div>